const QueryConstants = {
  ADD_A_FEED: 'addAFeed',
  POSTING_PATH: 'postingPath',
  SECURITY_TOKEN: 'securityToken',
  SIGN_IN_LP: 'signInLP',
  HAS_SUCCESS_REDIRECT_PATH: 'hasSuccessRedirectPath',
  CLAIM_DASHBOARD: 'claimDashboard',
  REDIRECT_TO: 'redirectTo',
  SUB_NAV_FILTER_TYPE: 'subNavFilterType',
  ARCHIVED: 'archived',
  SEARCH_TEXT: 'searchText',
  VIEW_MODE: 'viewMode',
  EXPANDED_GROUP: 'expandedGroup',
  SCROLL_TO: 'scrollTo',
  SHOW_MEDIA_CREDITS_MODAL: 'mediaCredits',
} as const;

export default QueryConstants;
